// @ts-nocheck
import { parseInt } from "lodash";
import { getUTCTimeDifferenceWithDate } from "./timeDiff";
import { DateTime } from "luxon";
import { getFullTimeEstimate, getOverTimeEstimate } from "./calcUtils";

// TODO: rathern than put tD, we'll put the startTime, endTime and timeZone, with that we'll make a function to send the estimate calculation.
export const calcEstimate = ({
  terms: term,
  appliedRate,
  data,
  breaks,
  isHalfDay,
  isHDOverride,
  isHourlyRate = false,
}) => {
  let terms = {
    halfDay: isHalfDay ? 0 : term?.halfDay,
    fullDay: isHalfDay ? term?.halfDay : term?.fullDay,
    // overTime: isHalfDay
    //   ? term?.fullDay + term?.overTime - term?.halfDay
    //   : term?.overTime,
    overTime: term?.overTime,
  };
  const { start, end, timezone, numberOfHours } = data;
  const originalStart = convertTime({ dateStr: start, timezone });
  const originalEnd = convertTime({ dateStr: end, timezone });
  const {
    timeDiff: tD,
    afterFullTime,
    overtime: overT,
  } = getTimeDiff(originalStart, originalEnd, terms);
  let timeDiff = parseFloat(tD || numberOfHours);

  if (afterFullTime) {
    const { halfDay: hD, fullDay: fD, overTime: oT } = terms;
    const halfDay = parseFloat(hD);
    const fullDay = parseFloat(fD);
    const overTime = parseFloat(oT);

    const firstBreak = parseFloat(breaks?.firstBreak) || 0;
    const secondBreak = parseFloat(breaks?.secondBreak) || 0;

    if (firstBreak) {
      timeDiff -= firstBreak;
    }
    if (secondBreak) {
      timeDiff -= secondBreak;
    }

    let estimate = 0;
    if (!timeDiff) {
      timeDiff = fullDay;
    }
    if (halfDay === 0 && fullDay === 0 && overTime === 0) {
      return 0;
    }
    if (timeDiff <= halfDay) {
      if (isHourlyRate) {
        estimate = appliedRate * timeDiff;
      } else {
        estimate = appliedRate * halfDay;
      }
    } else if (timeDiff <= fullDay) {
      if (isHourlyRate) {
        estimate = appliedRate * timeDiff;
      } else {
        estimate = appliedRate * fullDay;
      }
    } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
      estimate =
        appliedRate * fullDay + (timeDiff - fullDay) * (appliedRate * 1.5);
    } else {
      estimate =
        appliedRate * fullDay +
        overTime * (appliedRate * 1.5) +
        (timeDiff - fullDay - overTime) * (appliedRate * 2);
    }

    return estimate || 0;
  } else {
    const { halfDay: hD, fullDay: fD, overTime: oT } = terms;
    const halfDay = parseFloat(hD);
    const fullDay = parseFloat(fD);
    const overTime = parseFloat(oT);

    const firstBreak = parseFloat(breaks?.firstBreak) || 0;
    const secondBreak = parseFloat(breaks?.secondBreak) || 0;

    if (firstBreak) {
      timeDiff -= firstBreak;
    }
    if (secondBreak) {
      timeDiff -= secondBreak;
    }

    let overTimePay = overT * appliedRate * 1.5;
    let estimate = 0;
    if (!timeDiff) {
      timeDiff = fullDay;
    }
    if (halfDay === 0 && fullDay === 0 && overTime === 0) {
      return 0;
    }
    if (timeDiff <= halfDay) {
      if (isHourlyRate) {
        estimate = appliedRate * (timeDiff - overT) + overTimePay;
      } else {
        estimate = appliedRate * (halfDay - overT) + overTimePay;
      }
    } else if (timeDiff <= fullDay) {
      if (isHourlyRate) {
        estimate = appliedRate * (timeDiff - overT) + overTimePay;
      } else {
        estimate = appliedRate * (fullDay - overT) + overTimePay;
      }
    } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
      estimate =
        appliedRate * (fullDay - overT) +
        (timeDiff - fullDay) * (appliedRate * 1.5) +
        overTimePay;
    } else {
      estimate =
        appliedRate * (fullDay - overT) +
        overTime * (appliedRate * 1.5) +
        (timeDiff - fullDay - overTime) * (appliedRate * 2) +
        overTimePay;
    }

    return estimate || 0;
  }
};

export const calcFullAndOtEstimate = ({
  terms: term,
  appliedRate,
  data,
  breaks,
  isHalfDay,
  isHDOverride,
  isHourlyRate = false,
}) => {
  let terms = {
    halfDay: isHalfDay ? 0 : term?.halfDay,
    fullDay: isHalfDay ? term?.halfDay : term?.fullDay,
    // overTime: isHalfDay
    //   ? term?.fullDay + term?.overTime - term?.halfDay
    //   : term?.overTime,
    overTime: term?.overTime,
  };
  const { start, end, timezone, numberOfHours } = data;
  const originalStart = convertTime({ dateStr: start, timezone });
  const originalEnd = convertTime({ dateStr: end, timezone });
  const {
    timeDiff: tD,
    afterFullTime,
    overtime: overT,
  } = getTimeDiff(originalStart, originalEnd, terms);
  // const afterFullTime = true;
  // const overT = 0;
  let timeDiff = parseFloat(tD || numberOfHours);

  const { halfDay: hD, fullDay: fD, overTime: oT } = terms;
  const halfDay = parseFloat(hD);
  const fullDay = parseFloat(fD);
  const overTime = parseFloat(oT);

  const firstBreak = parseFloat(breaks?.firstBreak) || 0;
  const secondBreak = parseFloat(breaks?.secondBreak) || 0;

  if (firstBreak) {
    timeDiff -= firstBreak;
  }
  if (secondBreak) {
    timeDiff -= secondBreak;
  }

  let fullTimeEstimate = 0;
  let overTimeEstimate = 0;

  if (!timeDiff) {
    timeDiff = fullDay;
  }

  if (halfDay === 0 && fullDay === 0 && overTime === 0) {
    return { fullTimeEstimate, overTimeEstimate };
  }

  let hours = 0,
    otHours = 0,
    dtHours = 0;

  if (afterFullTime) {
    if (timeDiff <= halfDay) {
      if (isHourlyRate) {
        fullTimeEstimate = appliedRate * timeDiff;
        hours = timeDiff;
      } else {
        fullTimeEstimate = appliedRate * halfDay;
        hours = halfDay;
      }
    } else if (timeDiff <= fullDay) {
      if (isHourlyRate) {
        fullTimeEstimate = appliedRate * timeDiff;
        hours = timeDiff;
      } else {
        fullTimeEstimate = appliedRate * fullDay;
        hours = fullDay;
      }
    } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
      fullTimeEstimate = appliedRate * fullDay;
      overTimeEstimate = (timeDiff - fullDay) * (appliedRate * 1.5);
      hours = fullDay;
      otHours = timeDiff - fullDay;
    } else {
      fullTimeEstimate = appliedRate * fullDay;
      overTimeEstimate =
        overTime * (appliedRate * 1.5) +
        (timeDiff - fullDay - overTime) * (appliedRate * 2);
      hours = fullDay;
      otHours = overTime;
      dtHours = timeDiff - fullDay - overTime;
    }
  } else {
    // const overTimePay = overT * appliedRate * 1.5;
    const overTimePay = 0;

    if (timeDiff <= halfDay) {
      if (isHourlyRate) {
        fullTimeEstimate = appliedRate * (timeDiff - overT);
        overTimeEstimate = overTimePay;
        hours = timeDiff - overT;
      } else {
        fullTimeEstimate = appliedRate * (halfDay - overT);
        overTimeEstimate = overTimePay;
        hours = halfDay - overT;
      }
    } else if (timeDiff <= fullDay) {
      if (isHourlyRate) {
        fullTimeEstimate = appliedRate * (timeDiff - overT);
        overTimeEstimate = overTimePay;
        hours = timeDiff - overT;
      } else {
        fullTimeEstimate = appliedRate * (fullDay - overT);
        overTimeEstimate = overTimePay;
        hours = fullDay - overT;
      }
    } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
      fullTimeEstimate = appliedRate * (fullDay - overT);
      overTimeEstimate =
        overTimePay + (timeDiff - fullDay) * (appliedRate * 1.5);
      hours = fullDay - overT;
      otHours = timeDiff - fullDay;
    } else {
      fullTimeEstimate = appliedRate * (fullDay - overT);
      overTimeEstimate =
        overTimePay +
        overTime * (appliedRate * 1.5) +
        (timeDiff - fullDay - overTime) * (appliedRate * 2);

      hours = fullDay - overT;
      otHours = overTime;
      dtHours = timeDiff - fullDay - overTime;
    }
  }

  return {
    fullTimeEstimate: getFullTimeEstimate({
      fullTimeEstimate,
      totalHours: overT + hours,
      rate: appliedRate,
    }),
    overTimeEstimate: getOverTimeEstimate({
      overTimeEstimate,
      overT,
      otHours,
      dtHours,
      rate: appliedRate,
    }),
    overT,
    hours,
    otHours,
    dtHours,
  };
};

// export const calcEstimate = (terms, appliedRate, tD, breaks) => {
//   let timeDiff = tD;
//   const { halfDay: hD, fullDay: fD, overTime: oT } = terms;
//   const halfDay = parseFloat(hD);
//   const fullDay = parseFloat(fD);
//   const overTime = parseFloat(oT);
//
//   const firstBreak = parseFloat(breaks?.firstBreak) || 0;
//   const secondBreak = parseFloat(breaks?.secondBreak) || 0;
//
//   if (firstBreak) {
//     timeDiff -= firstBreak;
//   }
//   if (secondBreak) {
//     timeDiff -= secondBreak;
//   }
//
//   let estimate = 0;
//   if (!timeDiff) {
//     timeDiff = fullDay;
//   }
//   if (halfDay === 0 || fullDay === 0 || overTime === 0) {
//     return 0;
//   }
//   if (timeDiff <= halfDay) {
//     estimate = appliedRate * halfDay;
//   } else if (timeDiff <= fullDay) {
//     estimate = appliedRate * fullDay;
//   } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
//     estimate =
//       appliedRate * fullDay + (timeDiff - fullDay) * (appliedRate * 1.5);
//   } else {
//     estimate =
//       appliedRate * fullDay +
//       overTime * (appliedRate * 1.5) +
//       (timeDiff - fullDay - overTime) * (appliedRate * 2);
//   }
//
//   return estimate || 0;
// };

// TODO: rathern than put tD, we'll put the startTime, endTime and timeZone, with that we'll make a function to send the estimate calculation and with also get the over times and full time rate.
// export const calcFullAndOtEstimate = (terms, appliedRate, tD, breaks) => {
//   let timeDiff = tD;
//   const { halfDay: hD, fullDay: fD, overTime: oT } = terms;
//   const halfDay = parseFloat(hD);
//   const fullDay = parseFloat(fD);
//   const overTime = parseFloat(oT);
//
//   const firstBreak = parseFloat(breaks?.firstBreak) || 0;
//   const secondBreak = parseFloat(breaks?.secondBreak) || 0;
//
//   if (firstBreak) {
//     timeDiff -= firstBreak;
//   }
//   if (secondBreak) {
//     timeDiff -= secondBreak;
//   }
//
//   let fullTimeEstimate = 0;
//   let overTimeEstimate = 0;
//   if (!timeDiff) {
//     timeDiff = fullDay;
//   }
//
//   if (halfDay === 0 || fullDay === 0 || overTime === 0) {
//     return { fullTimeEstimate, overTimeEstimate };
//   }
//
//   if (timeDiff <= halfDay) {
//     fullTimeEstimate = appliedRate * halfDay;
//   } else if (timeDiff <= fullDay) {
//     fullTimeEstimate = appliedRate * fullDay;
//   } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
//     fullTimeEstimate = appliedRate * fullDay;
//     overTimeEstimate = (timeDiff - fullDay) * (appliedRate * 1.5);
//   } else {
//     fullTimeEstimate = appliedRate * fullDay;
//     overTimeEstimate =
//       overTime * (appliedRate * 1.5) +
//       (timeDiff - fullDay - overTime) * (appliedRate * 2);
//   }
//
//   return { fullTimeEstimate, overTimeEstimate };
// };

export function getBreaks(pos, discardSecondBreak = false) {
  if (pos?.selectOption?.toLowerCase() !== "1 hour walk away") return null;
  if (
    isTimeTBD(pos?.timeIn) &&
    isTimeTBD(pos?.timeOut) &&
    !pos?.actualStart &&
    !pos?.actualEnd
  ) {
    if (pos?.numberOfHours > 5) {
      return {
        firstBreak: 1,
        secondBreak: 0,
      };
    }
  }

  return {
    firstBreak:
      pos?.firstBreak && pos?.afterFirstBreakIn
        ? getUTCTimeDifferenceWithDate(pos?.firstBreak, pos?.afterFirstBreakIn)
        : 0,
    secondBreak: discardSecondBreak
      ? 0
      : pos?.secondBreak && pos?.afterSecondBreakIn
        ? getUTCTimeDifferenceWithDate(
            pos?.secondBreak,
            pos?.afterSecondBreakIn,
          )
        : 0,
  };
}

export function getBreaksEstimate(pos, discardSecondBreak = false) {
  if (pos?.selectOption?.toLowerCase() !== "1 hour walk away") return null;
  if (isTimeTBD(pos?.timeIn) && isTimeTBD(pos?.timeOut)) {
    if (pos?.numberOfHours > 5) {
      return {
        firstBreak: 1,
        secondBreak: 0,
      };
    }
  }

  return {
    firstBreak:
      pos?.firstBreak && pos?.afterFirstBreakIn
        ? getUTCTimeDifferenceWithDate(pos?.firstBreak, pos?.afterFirstBreakIn)
        : 0,
    secondBreak: discardSecondBreak
      ? 0
      : pos?.secondBreak && pos?.afterSecondBreakIn
        ? getUTCTimeDifferenceWithDate(
            pos?.secondBreak,
            pos?.afterSecondBreakIn,
          )
        : 0,
  };
}

export function isTimeTBD(str) {
  if (!str) return true;
  if (str?.toLowerCase() === "tbd") return true;
  else return false;
}

const convertTime = ({ dateStr, timezone }) => {
  let returnVal = "";
  const utcDateTime = DateTime.fromISO(dateStr, { zone: "UTC" });

  // Convert the UTC time to the specified timezone
  const localDateTime = utcDateTime.setZone(timezone);

  // Return the local time in ISO format with the appropriate local timezone offset
  const splittedDate = localDateTime?.toISO()?.split("T");

  const time = splittedDate?.[1]?.split("-")?.[0];

  // returnVal = splittedDate?.[0] + "T" + time?.split("+")?.[0];
  returnVal = splittedDate?.[0] + "T" + time?.split("+")?.[0] + "Z";

  return returnVal;
};

export function getTimeDiff(utcDate1, utcDate2, terms) {
  try {
    if (!utcDate1 || !utcDate2 || !terms) {
      throw new Error("Missing required inputs");
    }

    const date1 = Date.parse(utcDate1);
    let date2 = Date.parse(utcDate2);

    if (isNaN(date1) || isNaN(date2)) {
      throw new Error("Invalid date format");
    }

    const dayInMilliseconds = 24 * 60 * 60 * 1000;
    if (date2 <= date1) {
      date2 += dayInMilliseconds;
      if (date2 <= date1) {
        date2 += dayInMilliseconds;
      }
    }

    let difference = date2 - date1;

    const absoluteDifference = Math.abs(difference);
    const hoursDifference = absoluteDifference / (1000 * 60 * 60);
    const diff = hoursDifference.toFixed(2);

    const fullDayMilliseconds = terms.fullDay * 60 * 60 * 1000;

    let midnightMilliseconds = date1 - date1 * dayInMilliseconds;

    if (date2 - date1 >= dayInMilliseconds) {
      midnightMilliseconds = date1 - (date1 % dayInMilliseconds);
    } else {
      midnightMilliseconds = date2 - (date2 % dayInMilliseconds);
    }
    const midnightTo8amStart = midnightMilliseconds;
    // NOTE: changed to midnight to 6am
    const midnightTo8amEnd = midnightMilliseconds + 6 * 60 * 60 * 1000;

    const fullTimeEnd = Math.min(date1 + fullDayMilliseconds, date2);
    // const fullTimeEnd = date1 + fullDayMilliseconds;

    let afterFullTime = false;
    let overtime = 0;

    const overlapStart = Math.max(midnightTo8amStart, date1);
    const overlapEnd = Math.min(midnightTo8amEnd, fullTimeEnd);

    if (overlapEnd > overlapStart) {
      overtime = (overlapEnd - overlapStart) / (1000 * 60 * 60);
      overtime = parseFloat(overtime.toFixed(2));
    } else {
      overtime = 0;
    }

    if (fullTimeEnd <= midnightTo8amStart) {
      afterFullTime = true;
    }

    return { timeDiff: diff, afterFullTime, overtime };
  } catch (error) {
    return { timeDiff: 0, afterFullTime: true, overtime: 0 };
  }
}

// export function calculateBreakHours({
//   timeIn,
//   timeOut,
//   timezone,
//   isWalkaway,
//   numberOfHours,
// }) {
//   if (!isWalkaway) return 0; // Breaks are counted only if isWalkaway is true.
//
//   // Handle TBD case with `numberOfHours`.
//   if (isTimeTBD(timeIn) || isTimeTBD(timeOut)) {
//     const noh = parseInt(numberOfHours);
//     if (noh > 12) {
//       return 2; // More than 12 hours → 2 breaks.
//     } else if (noh > 6) {
//       return 1; // More than 6 hours → 1 break.
//     }
//     return 0; // Less than or equal to 6 hours → no breaks.
//   }
//
//   const convertToTimeNumber = (timeStr) => {
//     const [hours, minutes] = timeStr.split(":").map(Number);
//     return hours * 100 + minutes;
//   };
//
//   const getTimeDifference = (start, end) => {
//     const startHours = Math.floor(start / 100) + (start % 100) / 60;
//     const endHours = Math.floor(end / 100) + (end % 100) / 60;
//     return endHours >= startHours
//       ? endHours - startHours
//       : 24 - startHours + endHours;
//   };
//
//   // Use `convertTime` function to adjust time based on timezone.
//   const convertedTimeIn = convertTime({ dateStr: timeIn, timezone });
//   const convertedTimeOut = convertTime({ dateStr: timeOut, timezone });
//
//   let startTime = convertToTimeNumber(convertedTimeIn);
//   let endTime = convertToTimeNumber(convertedTimeOut);
//
//   let totalHours = getTimeDifference(startTime, endTime);
//
//   if (totalHours === 0) return 0; // No work hours, no breaks.
//
//   // Exclude hours between midnight and 8 AM.
//   let adjustedHours = totalHours;
//   if (startTime < 800) {
//     const before8AM = getTimeDifference(startTime, Math.min(800, endTime));
//     adjustedHours -= before8AM;
//   }
//   if (endTime < 800) {
//     const after12AM = getTimeDifference(Math.max(startTime, 0), endTime);
//     adjustedHours -= after12AM;
//   }
//
//   // Break rules:
//   let breaks = 0;
//   if (adjustedHours > 12) {
//     breaks = 2; // More than 12 hours → 2 breaks.
//   } else if (adjustedHours > 6) {
//     breaks = 1; // More than 6 hours → 1 break.
//   }
//
//   // Ensure breaks are spaced correctly.
//   const breakDuration = 1;
//   const remainingTimeAfterBreaks = adjustedHours - breaks * breakDuration;
//   if (remainingTimeAfterBreaks <= 0) {
//     breaks = Math.max(0, Math.floor(adjustedHours / (breakDuration + 1)));
//   }
//
//   return breaks * breakDuration; // Total hours spent on breaks.
// }

export function calculateBreakHours({
  timeIn,
  timeOut,
  timezone,
  isWalkaway,
  numberOfHours,
}) {
  if (!isWalkaway) {
    return 0; // Breaks are counted only if isWalkaway is true.
  }

  // Handle TBD case with `numberOfHours`.
  if (isTimeTBD(timeIn) || isTimeTBD(timeOut)) {
    const noh = parseInt(numberOfHours);

    if (noh > 12) {
      return 2; // More than 12 hours → 2 breaks.
    } else if (noh > 6) {
      return 1; // More than 6 hours → 1 break.
    }
    return 0; // Less than or equal to 6 hours → no breaks.
  }

  const convertToTimeNumber = (timeStr) => {
    // Extract the hours and minutes from the ISO string
    const [hours, minutes] = timeStr.split("T")[1].split(":").map(Number);
    return hours * 100 + minutes;
  };

  const getTimeDifference = (start, end) => {
    const startHours = Math.floor(start / 100) + (start % 100) / 60;
    const endHours = Math.floor(end / 100) + (end % 100) / 60;
    return endHours >= startHours
      ? endHours - startHours
      : 24 - startHours + endHours;
  };

  // Use `convertTime` function to adjust time based on timezone.
  const convertedTimeIn = convertTime({ dateStr: timeIn, timezone });
  const convertedTimeOut = convertTime({ dateStr: timeOut, timezone });

  let startTime = convertToTimeNumber(convertedTimeIn);
  let endTime = convertToTimeNumber(convertedTimeOut);

  let totalHours = getTimeDifference(startTime, endTime);

  if (totalHours === 0) {
    return 0; // No work hours, no breaks.
  }

  // Exclude hours between midnight and 8 AM.
  let adjustedHours = totalHours;
  if (startTime < 800) {
    const before8AM = getTimeDifference(startTime, Math.min(800, endTime));
    adjustedHours -= before8AM;
  }
  if (endTime < 800) {
    const after12AM = getTimeDifference(Math.max(startTime, 0), endTime);
    adjustedHours -= after12AM;
  }

  // Break rules:
  let breaks = 0;
  if (adjustedHours > 12) {
    breaks = 2; // More than 12 hours → 2 breaks.
  } else if (adjustedHours > 6) {
    breaks = 1; // More than 6 hours → 1 break.
  } else {}

  // Ensure breaks are spaced correctly.
  const breakDuration = 1;
  const remainingTimeAfterBreaks = adjustedHours - breaks * breakDuration;
  if (remainingTimeAfterBreaks <= 0) {
    breaks = Math.max(0, Math.floor(adjustedHours / (breakDuration + 1)));
  }

  return breaks * breakDuration; // Total hours spent on breaks.
}

export const calcEstimateForPO = ({
  terms: term,
  appliedRate,
  data,
  breaks,
  givenOtAndDt,
  isHalfDay,
  isHourlyRate = false,
}) => {
  const terms = {
    halfDay: isHalfDay ? 0 : term?.halfDay,
    fullDay: isHalfDay ? term?.halfDay : term?.fullDay,
    overTime: term?.overTime,
  };
  const { start, end, timezone, numberOfHours } = data;
  const originalStart = convertTime({ dateStr: start, timezone });
  const originalEnd = convertTime({ dateStr: end, timezone });
  const {
    timeDiff: tD,
    afterFullTime,
    overtime: overT,
  } = getTimeDiff(originalStart, originalEnd, terms);
  const { givenOt: gOt, givenDt: gDt, givenMOt: gMOt } = givenOtAndDt;
  const givenOt = parseFloat(gOt || 0);
  const givenDt = parseFloat(gDt || 0);
  const givenMOt = parseFloat(gMOt || 0);

  let timeDiff = parseFloat(tD || numberOfHours);
  const { halfDay: hD, fullDay: fD, overTime: oT } = terms;
  const halfDay = parseFloat(hD);
  const fullDay = parseFloat(fD);
  const overTime = parseFloat(oT);

  const firstBreak = parseFloat(breaks?.firstBreak) || 0;
  const secondBreak = parseFloat(breaks?.secondBreak) || 0;

  let otHours = 0;
  let dtHours = 0;
  let ftHours = 0;
  if (!(gOt || gDt || gMOt)) {
    if (afterFullTime) {
      if (firstBreak) {
        timeDiff -= firstBreak;
      }
      if (secondBreak) {
        timeDiff -= secondBreak;
      }

      let estimate = 0;
      if (!timeDiff) {
        timeDiff = fullDay;
      }
      if (halfDay === 0 && fullDay === 0 && overTime === 0) {
        return 0;
      }
      if (timeDiff <= halfDay) {
        if (isHourlyRate) {
          estimate = appliedRate * timeDiff;
        } else {
          estimate = appliedRate * halfDay;
        }
        ftHours = halfDay;
      } else if (timeDiff <= fullDay) {
        if (isHourlyRate) {
          estimate = appliedRate * timeDiff;
          ftHours = timeDiff;
        } else {
          estimate = appliedRate * fullDay;
          ftHours = fullDay;
        }
      } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
        otHours = timeDiff - fullDay;
        estimate = appliedRate * fullDay + otHours * (appliedRate * 1.5);
        ftHours = fullDay;
      } else {
        otHours = overTime;
        dtHours = timeDiff - fullDay - overTime;
        ftHours = fullDay;
        estimate =
          appliedRate * fullDay +
          overTime * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2);
      }

      return {
        estimate: estimate || 0,
        totalHours: timeDiff,
        overT: 0,
        ftHours,
        otHours,
        dtHours,
      };
    } else {
      if (firstBreak) {
        timeDiff -= firstBreak;
      }
      if (secondBreak) {
        timeDiff -= secondBreak;
      }

      let overTimePay = overT * appliedRate * 1.5;
      let estimate = 0;
      if (!timeDiff) {
        timeDiff = fullDay;
      }
      if (halfDay === 0 && fullDay === 0 && overTime === 0) {
        return 0;
      }
      if (timeDiff <= halfDay) {
        if (isHourlyRate) {
          ftHours = timeDiff - overT;
          estimate = appliedRate * (timeDiff - overT) + overTimePay;
        } else {
          // otHours = overT;
          ftHours = halfDay - overT;
          estimate = appliedRate * (halfDay - overT) + overTimePay;
        }
      } else if (timeDiff <= fullDay) {
        if (isHourlyRate) {
          ftHours = timeDiff - overT;
          estimate = appliedRate * (timeDiff - overT) + overTimePay;
        } else {
          // otHours = overT;
          ftHours = fullDay - overT;
          estimate = appliedRate * (fullDay - overT) + overTimePay;
        }
      } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
        // otHours = overT + (timeDiff - fullDay);
        otHours = timeDiff - fullDay;
        ftHours = fullDay - overT;
        estimate =
          appliedRate * (fullDay - overT) +
          (timeDiff - fullDay) * (appliedRate * 1.5) +
          overTimePay;
      } else {
        // otHours = overTime + overT;
        otHours = overTime;
        dtHours = timeDiff - fullDay - overTime;
        ftHours = fullDay - overT;
        estimate =
          appliedRate * (fullDay - overT) +
          overTime * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2) +
          overTimePay;
      }

      return {
        estimate: estimate || 0,
        totalHours: timeDiff,
        overT,
        ftHours,
        otHours,
        dtHours,
      };
    }
  } else {
    if (firstBreak) {
      timeDiff -= firstBreak;
    }
    if (secondBreak) {
      timeDiff -= secondBreak;
    }
    let fixedFt = 0;
    if (!(givenOt || givenDt)) {
      if (timeDiff <= terms?.fullDay && timeDiff > terms?.halfDay) {
        fixedFt = terms?.fullDay;
      } else if (timeDiff <= terms?.halfDay && timeDiff > 0) {
        fixedFt = terms?.halfDay;
      }
    }

    let midnightHoursPrice = givenMOt * 0.5 * appliedRate;

    if (gOt && gDt) {
      otHours = givenOt;
      dtHours = givenDt;
      // const ftHours = Math.max(timeDiff - givenOt - givenDt, 0, fixedFt);
      let initialFtHours = 0;
      if (isHourlyRate) {
        initialFtHours = Math.max(timeDiff - givenOt - givenDt, 0);
      } else {
        initialFtHours = Math.max(timeDiff - givenOt - givenDt, 0, fixedFt);
      }
      let ftHours;

      if (initialFtHours <= halfDay && !isHourlyRate) {
        ftHours = halfDay;
      } else if (initialFtHours <= fullDay && !isHourlyRate) {
        ftHours = fullDay;
      } else {
        // Round up to nearest 0.5
        ftHours = Math.ceil(initialFtHours * 2) / 2;
      }
      let estimate = 0;
      estimate =
        ftHours * appliedRate +
        otHours * (appliedRate * 1.5) +
        dtHours * (appliedRate * 2) +
        midnightHoursPrice;
      return {
        estimate,
        totalHours: timeDiff,
        ftHours,
        otHours,
        dtHours,
        overT: givenMOt,
      };
    } else if (gOt && !gDt) {
      otHours = givenOt;
      let estimate = 0;
      let ftHours = 0;
      let initialFtHours = 0;
      if (timeDiff <= fullDay) {
        initialFtHours = timeDiff - otHours;
        if (initialFtHours <= halfDay && !isHourlyRate) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay && !isHourlyRate) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        estimate =
          ftHours * appliedRate +
          otHours * (appliedRate * 1.5) +
          midnightHoursPrice;
      } else {
        let ftHours = 0;
        let initialFtHours = 0;
        dtHours = Math.max(timeDiff - fullDay - otHours, 0, fixedFt);
        initialFtHours = timeDiff - dtHours - otHours;
        if (initialFtHours <= halfDay && !isHourlyRate) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay && !isHourlyRate) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        estimate =
          ftHours * appliedRate +
          otHours * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2) +
          midnightHoursPrice;
      }
      return {
        estimate,
        totalHours: timeDiff,
        ftHours,
        otHours,
        dtHours,
        overT: givenMOt,
      };
    } else if (gDt && !gOt) {
      let ftHours = 0;
      let initialFtHours = 0;
      dtHours = givenDt;
      let estimate = 0;
      if (timeDiff <= fullDay) {
        initialFtHours = timeDiff - dtHours;
        if (initialFtHours <= halfDay && !isHourlyRate) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay && !isHourlyRate) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        estimate =
          ftHours * appliedRate +
          dtHours * (appliedRate * 2) +
          midnightHoursPrice;
      } else {
        let ftHours = 0;
        let initialFtHours = 0;
        otHours = Math.max(timeDiff - fullDay - dtHours, 0, fixedFt);
        initialFtHours = timeDiff - otHours - dtHours;
        if (initialFtHours <= halfDay && !isHourlyRate) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay && !isHourlyRate) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        estimate =
          ftHours * appliedRate +
          otHours * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2) +
          midnightHoursPrice;
      }
      return {
        estimate,
        totalHours: timeDiff,
        ftHours,
        otHours,
        dtHours,
        overT: givenMOt,
      };
    }
  }
};

export const calcEstimateForInvoice = ({
  terms: term,
  appliedRate: aR,
  data,
  breaks,
  givenOtAndDt,
  isHalfDay,
  isHDOverride,
  isHourlyRate = false,
}) => {
  let terms = {
    halfDay: isHalfDay ? 0 : term?.halfDay,
    fullDay: isHalfDay ? term?.halfDay : term?.fullDay,
    // overTime: isHalfDay
    //   ? term?.fullDay + term?.overTime - term?.halfDay
    //   : term?.overTime,
    overTime: term?.overTime,
  };
  let appliedRate = aR;
  const { start, end, timezone, numberOfHours } = data;
  const originalStart = convertTime({ dateStr: start, timezone });
  const originalEnd = convertTime({ dateStr: end, timezone });
  const {
    timeDiff: tD,
    afterFullTime,
    overtime: overT,
  } = getTimeDiff(originalStart, originalEnd, terms);
  const { givenOt: gOt, givenDt: gDt, givenMOt: gMOt } = givenOtAndDt;
  const givenOt = parseFloat(gOt || 0);
  const givenDt = parseFloat(gDt || 0);
  const givenMOt = parseFloat(gMOt || 0);

  let timeDiff = parseFloat(tD || numberOfHours);
  if (timeDiff > term?.halfDay + 1 && !isHDOverride && isHalfDay) {
    terms = term;
    // appliedRate = aR - 5;
  }

  const { halfDay: hD, fullDay: fD, overTime: oT } = terms;
  const halfDay = parseFloat(hD);
  const fullDay = parseFloat(fD);
  const overTime = parseFloat(oT);

  const firstBreak = parseFloat(breaks?.firstBreak) || 0;
  const secondBreak = parseFloat(breaks?.secondBreak) || 0;

  let otHours = 0;
  let dtHours = 0;
  let ftHours = 0;
  if (!(gOt || gDt || gMOt)) {
    if (afterFullTime) {
      if (firstBreak) {
        timeDiff -= firstBreak;
      }
      if (secondBreak) {
        timeDiff -= secondBreak;
      }

      let estimate = 0;
      if (!timeDiff) {
        timeDiff = fullDay;
      }
      if (halfDay === 0 && fullDay === 0 && overTime === 0) {
        return 0;
      }
      if (timeDiff <= halfDay) {
        if (isHourlyRate) {
          estimate = appliedRate * timeDiff;
          ftHours = timeDiff;
        } else {
          estimate = appliedRate * halfDay;
          ftHours = halfDay;
        }
      } else if (timeDiff <= fullDay) {
        if (isHourlyRate) {
          estimate = appliedRate * timeDiff;
          ftHours = timeDiff;
        } else {
          estimate = appliedRate * fullDay;
          ftHours = fullDay;
        }
      } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
        otHours = timeDiff - fullDay;
        estimate = appliedRate * fullDay + otHours * (appliedRate * 1.5);
        ftHours = fullDay;
      } else {
        otHours = overTime;
        dtHours = timeDiff - fullDay - overTime;
        ftHours = fullDay;
        estimate =
          appliedRate * fullDay +
          overTime * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2);
      }

      return {
        estimate: estimate || 0,
        totalHours: timeDiff,
        overT: 0,
        ftHours,
        otHours,
        dtHours,
      };
    } else {
      if (firstBreak) {
        timeDiff -= firstBreak;
      }
      if (secondBreak) {
        timeDiff -= secondBreak;
      }

      let overTimePay = overT * appliedRate * 1.5;
      let estimate = 0;
      if (!timeDiff) {
        timeDiff = fullDay;
      }
      if (halfDay === 0 && fullDay === 0 && overTime === 0) {
        return 0;
      }
      if (timeDiff <= halfDay) {
        if (isHourlyRate) {
          ftHours = timeDiff - overT;
          estimate = appliedRate * (timeDiff - overT) + overTimePay;
        } else {
          // otHours = overT;
          ftHours = halfDay - overT;
          estimate = appliedRate * (halfDay - overT) + overTimePay;
        }
      } else if (timeDiff <= fullDay) {
        if (isHourlyRate) {
          ftHours = timeDiff - overT;
          estimate = appliedRate * (timeDiff - overT) + overTimePay;
        } else {
          // otHours = overT;
          ftHours = fullDay - overT;
          estimate = appliedRate * (fullDay - overT) + overTimePay;
        }
      } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
        // otHours = overT + (timeDiff - fullDay);
        otHours = timeDiff - fullDay;
        ftHours = fullDay - overT;
        estimate =
          appliedRate * (fullDay - overT) +
          (timeDiff - fullDay) * (appliedRate * 1.5) +
          overTimePay;
      } else {
        // otHours = overTime + overT;
        otHours = overTime;
        dtHours = timeDiff - fullDay - overTime;
        ftHours = fullDay - overT;
        estimate =
          appliedRate * (fullDay - overT) +
          overTime * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2) +
          overTimePay;
      }

      return {
        estimate: estimate || 0,
        totalHours: timeDiff,
        overT,
        ftHours,
        otHours,
        dtHours,
      };
    }
  } else {
    if (firstBreak) {
      timeDiff -= firstBreak;
    }
    if (secondBreak) {
      timeDiff -= secondBreak;
    }
    let fixedFt = 0;
    if (!(givenOt || givenDt)) {
      if (timeDiff <= terms?.fullDay && timeDiff > terms?.halfDay) {
        fixedFt = terms?.fullDay;
      } else if (timeDiff <= terms?.halfDay && timeDiff > 0) {
        fixedFt = terms?.halfDay;
      }
    }

    let midnightHoursPrice = givenMOt * 0.5 * appliedRate;

    if (gOt && gDt) {
      otHours = givenOt;
      dtHours = givenDt;
      // const ftHours = Math.max(timeDiff - givenOt - givenDt, 0, fixedFt);
      let ftHours = 0;
      let initialFtHours = 0;
      if (isHourlyRate) {
        initialFtHours = Math.max(timeDiff - givenOt - givenDt, 0);
      } else {
        initialFtHours = Math.max(timeDiff - givenOt - givenDt, 0, fixedFt);
      }

      if (initialFtHours <= halfDay && !isHourlyRate) {
        ftHours = halfDay;
      } else if (initialFtHours <= fullDay && !isHourlyRate) {
        ftHours = fullDay;
      } else {
        // Round up to nearest 0.5
        ftHours = Math.ceil(initialFtHours * 2) / 2;
      }
      let estimate = 0;
      estimate =
        (ftHours * appliedRate +
          otHours * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2)) |
        midnightHoursPrice;
      return {
        estimate,
        totalHours: timeDiff,
        ftHours,
        otHours,
        dtHours,
        overT: givenMOt,
      };
    } else if (gOt && !gDt) {
      otHours = givenOt;
      let estimate = 0;
      let ftHours = 0;
      let initialFtHours = 0;
      if (timeDiff <= fullDay) {
        initialFtHours = timeDiff - otHours;
        if (initialFtHours <= halfDay && !isHourlyRate) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay && !isHourlyRate) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        estimate =
          ftHours * appliedRate +
          otHours * (appliedRate * 1.5) +
          midnightHoursPrice;
      } else {
        let ftHours = 0;
        let initialFtHours = 0;
        dtHours = Math.max(timeDiff - fullDay - otHours, 0, fixedFt);
        initialFtHours = timeDiff - dtHours - otHours;
        if (initialFtHours <= halfDay && !isHourlyRate) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay && !isHourlyRate) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        estimate =
          ftHours * appliedRate +
          otHours * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2) +
          midnightHoursPrice;
      }
      return {
        estimate,
        totalHours: timeDiff,
        ftHours,
        otHours,
        dtHours,
        overT: givenMOt,
      };
    } else if (gDt && !gOt) {
      let ftHours = 0;
      let initialFtHours = 0;
      dtHours = givenDt;
      let estimate = 0;
      if (timeDiff <= fullDay) {
        initialFtHours = timeDiff - dtHours;
        if (initialFtHours <= halfDay && !isHourlyRate) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay && !isHourlyRate) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        estimate =
          ftHours * appliedRate +
          dtHours * (appliedRate * 2) +
          midnightHoursPrice;
      } else {
        let ftHours = 0;
        let initialFtHours = 0;
        otHours = Math.max(timeDiff - fullDay - dtHours, 0, fixedFt);
        initialFtHours = timeDiff - otHours - dtHours;
        if (initialFtHours <= halfDay && !isHourlyRate) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay && !isHourlyRate) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        estimate =
          ftHours * appliedRate +
          otHours * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2) +
          midnightHoursPrice;
      }
      return {
        estimate,
        totalHours: timeDiff,
        ftHours,
        otHours,
        dtHours,
        overT: givenMOt,
      };
    }
  }
};

export function formatValue(value) {
  try {
    if (value == null || isNaN(value)) throw new Error("Invalid input");

    let num = typeof value === "string" ? parseFloat(value) : value;

    if (isNaN(num)) throw new Error("Invalid number");

    num = Math.round(num * 10) / 10;

    return Number.isInteger(num) ? num.toString() : num.toFixed(1);
  } catch {
    return "";
  }
}

export function getRateThoughHoursIdx(idx) {
  switch (idx) {
    case 0:
      return 1;
    case 1:
      return 0.5;
    case 2:
      return 1.5;
    case 3:
      return 2;
    case 4:
      return 1.5;
  }
}

export function getDescriptionThoughHoursIdx(idx, isHalfDay) {
  switch (idx) {
    case 0:
      if (isHalfDay) {
        return "Half Day Rate -";
      } else {
        return null;
      }
    case 1:
      return "After Midnight Rate -";
    case 2:
      return "Over Time Rate -";
    case 3:
      return "Double Time Rate -";
    case 4:
      return "Meal Penalty Rate -";
  }
}
export function getDescriptionThoughHoursIdxInvoice(idx, isHalfDay) {
  switch (idx) {
    case 0:
      if (isHalfDay) {
        return "HD";
      } else {
        return null;
      }
    case 1:
      return "Midnight OT";
    case 2:
      return "OT";
    case 3:
      return "DT";
    case 4:
      return "MP";
  }
}

export function getTimeDiffOfPositionsOnlyNumberOfHours({
  pos,
  eventInfo,
  terms,
}) {
  if (isTimeTBD(pos?.timeIn) || isTimeTBD(pos?.timeOut))
    return pos?.numberOfHours;
  else {
    const { timeDiff } = getTimeDiff(
      convertTime({ dateStr: pos?.timeIn, timezone: eventInfo?.eventTimezone }),
      convertTime({
        dateStr: pos?.timeOut,
        timezone: eventInfo?.eventTimezone,
      }),
      {
        halfDay: terms?.halfDay,
        fullDay: terms?.fullDay,
        overTime: terms?.overTime,
      },
    );
    return timeDiff;
  }
}

export const calcEstimateCalifornia = ({
  terms: term,
  appliedRate,
  data,
  breaks,
  isHalfDay,
  isHDOverride,
  isHourlyRate = false,
}) => {
  let terms = {
    halfDay: isHalfDay ? 0 : term?.halfDay,
    fullDay: isHalfDay ? term?.halfDay : term?.fullDay,
    overTime: term?.overTime,
  };
  let fixedTerms = {
    halfDay: 5,
    fullDay: 10,
    overTime: 2,
  };
  const { start, end, timezone, numberOfHours } = data;
  const originalStart = convertTime({ dateStr: start, timezone });
  const originalEnd = convertTime({ dateStr: end, timezone });
  const {
    timeDiff: tD,
    afterFullTime,
    overtime: overT,
  } = getTimeDiff(originalStart, originalEnd, terms);

  let timeDiff = parseFloat(tD || numberOfHours);

  if (afterFullTime) {
    const { halfDay: hD, fullDay: fD, overTime: oT } = terms;
    const halfDay = parseFloat(hD);
    const fullDay = parseFloat(fD);
    const overTime = parseFloat(oT);

    const firstBreak = parseFloat(breaks?.firstBreak) || 0;
    const secondBreak = parseFloat(breaks?.secondBreak) || 0;

    if (firstBreak) {
      timeDiff -= firstBreak;
    }
    if (secondBreak) {
      timeDiff -= secondBreak;
    }

    let estimate = 0;
    if (!timeDiff) {
      timeDiff = fullDay;
    }
    if (halfDay === 0 && fullDay === 0 && overTime === 0) {
      return 0;
    }
    if (timeDiff <= halfDay) {
      if (isHourlyRate) {
        estimate = appliedRate * timeDiff;
      } else {
        estimate = appliedRate * halfDay;
      }
    } else if (timeDiff <= fixedTerms.fullDay) {
      if (isHourlyRate) {
        estimate = appliedRate * timeDiff + appliedRate * 1.5 * 2;
      } else {
        estimate = appliedRate * fullDay + appliedRate * 1.5 * 2;
      }
    } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
      estimate =
        appliedRate * fullDay + (timeDiff - fullDay) * (appliedRate * 1.5);
    } else {
      estimate =
        appliedRate * fullDay +
        overTime * (appliedRate * 1.5) +
        (timeDiff - fullDay - overTime) * (appliedRate * 2);
    }

    return estimate || 0;
  } else {
    const { halfDay: hD, fullDay: fD, overTime: oT } = terms;
    const halfDay = parseFloat(hD);
    const fullDay = parseFloat(fD);
    const overTime = parseFloat(oT);

    const firstBreak = parseFloat(breaks?.firstBreak) || 0;
    const secondBreak = parseFloat(breaks?.secondBreak) || 0;

    if (firstBreak) {
      timeDiff -= firstBreak;
    }
    if (secondBreak) {
      timeDiff -= secondBreak;
    }

    let overTimePay = overT * appliedRate * 1.5;
    let estimate = 0;
    if (!timeDiff) {
      timeDiff = fullDay;
    }
    if (halfDay === 0 && fullDay === 0 && overTime === 0) {
      return 0;
    }
    if (timeDiff <= fixedTerms.halfDay) {
      if (isHourlyRate) {
        estimate = appliedRate * (timeDiff - overT) + overTimePay;
      } else {
        estimate = appliedRate * (halfDay - overT) + overTimePay;
      }
    } else if (timeDiff <= fixedTerms.fullDay) {
      if (isHourlyRate) {
        estimate =
          appliedRate * (timeDiff - overT) +
          overTimePay +
          appliedRate * 1.5 * 2;
      } else {
        estimate =
          appliedRate * (fullDay - overT) + overTimePay + appliedRate * 1.5 * 2;
      }
    } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
      estimate =
        appliedRate * (fullDay - overT) +
        (timeDiff - fullDay) * (appliedRate * 1.5) +
        overTimePay;
    } else {
      estimate =
        appliedRate * (fullDay - overT) +
        overTime * (appliedRate * 1.5) +
        (timeDiff - fullDay - overTime) * (appliedRate * 2) +
        overTimePay;
    }

    return estimate || 0;
  }
};

export const calcEstimateForCaliforniaPO = ({
  terms: term,
  appliedRate,
  data,
  breaks,
  givenOtAndDt,
  isHalfDay,
}) => {
  const terms = {
    halfDay: isHalfDay ? 0 : term?.halfDay,
    fullDay: isHalfDay ? term?.halfDay : term?.fullDay,
    overTime: term?.overTime,
  };
  let fixedTerms = {
    halfDay: 5,
    fullDay: 10,
    overTime: 2,
  };
  const { start, end, timezone, numberOfHours } = data;
  const originalStart = convertTime({ dateStr: start, timezone });
  const originalEnd = convertTime({ dateStr: end, timezone });
  const {
    timeDiff: tD,
    afterFullTime,
    overtime: overT,
  } = getTimeDiff(originalStart, originalEnd, terms);
  const { givenOt: gOt, givenDt: gDt } = givenOtAndDt;
  const givenOt = parseFloat(gOt || 0);
  const givenDt = parseFloat(gDt || 0);

  let timeDiff = parseFloat(tD || numberOfHours);
  const { halfDay: hD, fullDay: fD, overTime: oT } = terms;
  const halfDay = parseFloat(hD);
  const fullDay = parseFloat(fD);
  const overTime = parseFloat(oT);

  const firstBreak = parseFloat(breaks?.firstBreak) || 0;
  const secondBreak = parseFloat(breaks?.secondBreak) || 0;

  let otHours = 0;
  let dtHours = 0;
  let ftHours = 0;
  if (!(gOt || gDt)) {
    if (afterFullTime) {
      if (firstBreak) {
        timeDiff -= firstBreak;
      }
      if (secondBreak) {
        timeDiff -= secondBreak;
      }

      let estimate = 0;
      if (!timeDiff) {
        timeDiff = fullDay;
      }
      if (halfDay === 0 && fullDay === 0 && overTime === 0) {
        return 0;
      }
      if (timeDiff <= halfDay) {
        estimate = appliedRate * halfDay;
        ftHours = halfDay;
      } else if (timeDiff <= fixedTerms?.fullDay) {
        estimate = appliedRate * fullDay + appliedRate * 1.5 * 2;
        ftHours = fullDay;
        otHours = 2;
      } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
        otHours = timeDiff - fullDay;
        estimate = appliedRate * fullDay + otHours * (appliedRate * 1.5);
        ftHours = fullDay;
      } else {
        otHours = overTime;
        dtHours = timeDiff - fullDay - overTime;
        ftHours = fullDay;
        estimate =
          appliedRate * fullDay +
          overTime * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2);
      }

      return {
        estimate: estimate || 0,
        totalHours: timeDiff,
        ftHours,
        otHours,
        dtHours,
      };
    } else {
      if (firstBreak) {
        timeDiff -= firstBreak;
      }
      if (secondBreak) {
        timeDiff -= secondBreak;
      }

      let overTimePay = overT * appliedRate * 1.5;
      let estimate = 0;
      if (!timeDiff) {
        timeDiff = fullDay;
      }
      if (halfDay === 0 && fullDay === 0 && overTime === 0) {
        return 0;
      }
      if (timeDiff <= halfDay) {
        otHours = overT;
        ftHours = halfDay - overT;
        estimate = appliedRate * (halfDay - overT) + overTimePay;
      } else if (timeDiff <= fixedTerms.fullDay) {
        otHours = overT + 2;
        ftHours = fullDay - overT;
        estimate =
          appliedRate * (fullDay - overT) + overTimePay + appliedRate * 1.5 * 2;
      } else if (timeDiff <= Number(fullDay) + Number(overTime)) {
        otHours = overT + (timeDiff - fullDay);
        ftHours = fullDay - overT;
        estimate =
          appliedRate * (fullDay - overT) +
          (timeDiff - fullDay) * (appliedRate * 1.5) +
          overTimePay;
      } else {
        otHours = overTime + overT;
        dtHours = timeDiff - fullDay - overTime;
        ftHours = fullDay - overT;
        estimate =
          appliedRate * (fullDay - overT) +
          overTime * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2) +
          overTimePay;
      }

      return {
        estimate: estimate || 0,
        totalHours: timeDiff,
        ftHours,
        otHours,
        dtHours,
      };
    }
  } else {
    if (firstBreak) {
      timeDiff -= firstBreak;
    }
    if (secondBreak) {
      timeDiff -= secondBreak;
    }
    let fixedFt = 0;
    if (!(givenOt || givenDt)) {
      if (timeDiff <= terms?.fullDay && timeDiff > terms?.halfDay) {
        fixedFt = terms?.fullDay;
      } else if (timeDiff <= terms?.halfDay && timeDiff > 0) {
        fixedFt = terms?.halfDay;
      }
    }
    if (gOt && gDt) {
      otHours = givenOt;
      dtHours = givenDt;
      // const ftHours = Math.max(timeDiff - givenOt - givenDt, 0, fixedFt);
      const initialFtHours = Math.max(timeDiff - givenOt - givenDt, 0, fixedFt);
      let ftHours;
      if (initialFtHours <= halfDay) {
        ftHours = halfDay;
      } else if (initialFtHours <= fullDay) {
        ftHours = fullDay;
      } else {
        // Round up to nearest 0.5
        ftHours = Math.ceil(initialFtHours * 2) / 2;
      }
      let estimate = 0;
      estimate =
        ftHours * appliedRate +
        otHours * (appliedRate * 1.5) +
        dtHours * (appliedRate * 2);
      return { estimate, totalHours: timeDiff, ftHours, otHours, dtHours };
    } else if (gOt && !gDt) {
      otHours = givenOt;
      let estimate = 0;
      let ftHours = 0;
      let initialFtHours = 0;
      if (timeDiff <= fullDay) {
        initialFtHours = timeDiff - otHours;
        if (initialFtHours <= halfDay) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        // ftHours = timeDiff - otHours;
        estimate = ftHours * appliedRate + otHours * (appliedRate * 1.5);
      } else {
        let ftHours = 0;
        let initialFtHours = 0;
        dtHours = Math.max(timeDiff - fullDay - otHours, 0, fixedFt);
        // ftHours = timeDiff - dtHours - otHours;
        initialFtHours = timeDiff - dtHours - otHours;
        if (initialFtHours <= halfDay) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        estimate =
          ftHours * appliedRate +
          otHours * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2);
      }
      return { estimate, totalHours: timeDiff, ftHours, otHours, dtHours };
    } else if (gDt && !gOt) {
      let ftHours = 0;
      let initialFtHours = 0;
      dtHours = givenDt;
      let estimate = 0;
      if (timeDiff <= fullDay) {
        if (timeDiff <= fixedTerms.fullDay && timeDiff > halfDay) {
          ftHours = timeDiff - dtHours;
          otHours = 2;
          estimate =
            ftHours * appliedRate +
            dtHours * (appliedRate * 2) +
            appliedRate * 1.5 * 2;
        } else {
          // ftHours = timeDiff - dtHours;
          initialFtHours = timeDiff - dtHours;
          if (initialFtHours <= halfDay) {
            ftHours = halfDay;
          } else if (initialFtHours <= fullDay) {
            ftHours = fullDay;
          } else {
            // Round up to nearest 0.5
            ftHours = Math.ceil(initialFtHours * 2) / 2;
          }
          estimate = ftHours * appliedRate + dtHours * (appliedRate * 2);
        }
      } else {
        let ftHours = 0;
        let initialFtHours = 0;
        otHours = Math.max(timeDiff - fullDay - dtHours, 0, fixedFt);
        // ftHours = timeDiff - otHours - dtHours;
        initialFtHours = timeDiff - otHours - dtHours;
        if (initialFtHours <= halfDay) {
          ftHours = halfDay;
        } else if (initialFtHours <= fullDay) {
          ftHours = fullDay;
        } else {
          // Round up to nearest 0.5
          ftHours = Math.ceil(initialFtHours * 2) / 2;
        }
        estimate =
          ftHours * appliedRate +
          otHours * (appliedRate * 1.5) +
          dtHours * (appliedRate * 2);
      }
      return { estimate, totalHours: timeDiff, ftHours, otHours, dtHours };
    }
  }
};